<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <transition
          appear
          name="component-fade"
          mode="out-in"
        >
          <div v-if="subscribeComplete" key="complete" class="card">
            <div class="card-title primary white-text">
              <i class="material-icons icon">check</i>
              You're done!
            </div>
            <div class="card-content valign-wrapper" style="min-height:200px;">
              <div class="center-align" style="width:100%;">
                All that's left is to relax and wait for beautiful, engaging books
                to be delivered to your doorstep!<br>
                Message us on 9826612456 for any queries. Happy reading!<br><br>

                <router-link to="/subscription" class="btn btn-small">Go to subscriptions</router-link>
              </div>
            </div>
          </div>

          <div v-if="!subscribeComplete" key="form" class="card">
            <div class="card-title primary white-text">
              <i class="material-icons icon">list</i>
              Just a few more details
            </div>

            <div class="card-content">
              <div v-show="loadingAnimation && errorList === ''" class="progress">
                <div class="indeterminate"></div>
              </div>

              <div v-show="!loadingAnimation" class="row">
                <div class="col s12">
                  Select an age group/reading level
                </div>

                <div v-for="item in categoryList" :key="item.id" class="col s6 m3 center-align">
                  <div :class="['selection-box', (item.id === categoryID) ? 'active' : '']">
                    <a @click="chooseCategory(item.id)" class="waves-effect">
                      <img :src="'../img/' + item.id + '.svg'" :alt="item.title" style="max-height:100px;" class="img-responsive">
                      <div class="text mt-2">
                        For ages<br>
                        <b>{{ item.title }}</b>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div v-show="!loadingAnimation" class="row details-header">
                <div class="col s12 m6">
                  <div class="card z-depth-0 grey lighten-5">
                    <div class="card-title blue-grey lighten-5">
                      Deliver to:

                      <div class="right">
                        <div class="select-smaller">
                          <select v-model="deliveryAddressID">
                            <option
                              v-for="(item, key) in deliveryAddressList"
                              :key="key"
                              :value="key"
                            >{{ item.childName + ' (' + item.city + ')' }}</option>
                            <option value="ADD">Add New</option>
                          </select>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>

                    <div class="card-content">
                      <div v-if="deliveryDetails.name !== ''">
                        <b>{{ deliveryDetails.childName }}</b>
                        <div>
                          C/o {{ deliveryDetails.name }}<br>
                          {{ deliveryDetails.address }}<br>
                          {{ deliveryDetails.landmark }}<br>
                          {{ deliveryDetails.city }},
                          {{ deliveryDetails.state }}<br>
                          {{ deliveryDetails.country }},
                          {{ deliveryDetails.pincode }}
                        </div>
                        <b>Ph:</b> {{ deliveryDetails.phone1 }} {{ deliveryDetails.phone2 !== '' ? ' / ' + deliveryDetails.phone2 : '' }}
                      </div>
                      <div v-else>
                        We couldn't find an address for the subscription city. Please add a new address<br><br>
                        <a @click="openNewDialog" class="btn btn-small">Add</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col s12 m6">
                  <div class="card z-depth-0 grey lighten-5">
                    <div class="card-title blue-grey lighten-5">
                      Start subscription from:
                    </div>

                    <div class="card-content">
                      <div class="select-smaller">
                        <select v-model="planStart">
                          <option
                            v-for="(item, key) in planStartList"
                            :key="key"
                            :value="item.key"
                          >{{ item.date }}</option>
                        </select>
                      </div><br>

                      for {{ planDuration }} months
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="errorList !== ''" class="card-panel red lighten-4">
                <i class="material-icons left">warning</i>
                {{ errorList }}
              </div>
            </div>

            <div class="card-action blue-grey lighten-5">
              <a
                class="waves-effect waves-light btn green right"
                :disabled="loadingAnimation || saveInProgress"
                @click="completeSubscription"
              >
                Complete Subscription
                <i v-if="!saveInProgress" class="material-icons right">keyboard_arrow_right</i>
                <div v-if="saveInProgress" class="saving-animation">
                  <div class="lds-ripple">
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </a>
              <div class="clearfix"></div>
            </div>

            <div
              id="editModal"
              class="modal"
            >
              <div class="card mt-0 mb-0">
                <div class="card-title blue-grey lighten-5">
                  <i class="material-icons icon">home</i>
                  Add New Delivery Address
                </div>

                <div class="card-content">
                  <div class="row">
                    <div class="input-field col s12">
                      <input
                        autofocus
                        type="text"
                        id="childName"
                        v-model="editedItem.childName"
                      >
                      <label for="childName">Who is this subscription for?</label>
                      <span class="helper-text">Child's Name</span>
                      <span class="helper-text red-text">{{ (formErrors.childName !== '') ? formErrors.childName : '' }}</span>
                    </div>

                    <div class="input-field col s12">
                      <input
                        type="text"
                        class="datepicker"
                        id="dateOfBirth"
                        v-model.lazy="editedItem.dateOfBirth"
                      >
                      <label for="dateOfBirth">When was the recipient born?</label>
                      <span class="helper-text">We'll be sure to send a little gift!</span>
                      <span class="helper-text red-text">{{ (formErrors.dateOfBirth !== '') ? formErrors.dateOfBirth : '' }}</span>
                    </div>

                    <div class="input-field col s12">
                      <input
                        type="text"
                        id="name"
                        v-model="editedItem.name"
                      >
                      <label for="name">Your Name</label>
                      <span class="helper-text">Parent's/Adult's name</span>
                      <span class="helper-text red-text">{{ (formErrors.name !== '') ? formErrors.name : '' }}</span>
                    </div>

                    <div class="input-field col s12">
                      <textarea
                        id="address"
                        v-model="editedItem.address"
                        class="materialize-textarea"
                      ></textarea>
                      <label for="address">Address</label>
                      <span class="helper-text red-text">{{ (formErrors.address !== '') ? formErrors.address : 'House / Flat no, Locality' }}</span>
                    </div>

                    <div class="input-field col s12">
                      <input
                        type="text"
                        id="landmark"
                        v-model="editedItem.landmark"
                      >
                      <label for="landmark">Landmark</label>
                      <span class="helper-text red-text">{{ (formErrors.landmark !== '') ? formErrors.landmark : '' }}</span>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="city"
                        v-model="editedItem.city"
                        :readonly="shippingLocationID === '1'"
                      >
                      <span v-if="shippingLocationID === '1'" class="suffix" style="top:0.2rem;">
                        <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">lock</i>
                      </span>
                      <label for="city">City</label>
                      <span class="helper-text red-text">{{ (formErrors.city !== '') ? formErrors.city : '' }}</span>
                    </div>
                    <div class="clearfix"></div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="pincode"
                        v-model="editedItem.pincode"
                      >
                      <label for="pincode">Postal Code</label>
                      <span class="helper-text red-text">{{ (formErrors.pincode !== '') ? formErrors.pincode : '' }}</span>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="state"
                        v-model="editedItem.state"
                      >
                      <label for="state">State</label>
                      <span class="helper-text red-text">{{ (formErrors.state !== '') ? formErrors.state : '' }}</span>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="country"
                        v-model="editedItem.country"
                        readonly
                      >
                      <span class="suffix" style="top:0.2rem;">
                        <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">lock</i>
                      </span>
                      <label for="country">Country</label>
                      <span class="helper-text red-text">{{ (formErrors.country !== '') ? formErrors.country : '' }}</span>
                    </div>
                    <div class="clearfix"></div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="phone1"
                        v-model="editedItem.phone1"
                      >
                      <label for="phone1">Phone 1</label>
                      <span class="helper-text red-text">{{ (formErrors.phone1 !== '') ? formErrors.phone1 : '' }}</span>
                    </div>

                    <div class="input-field col s12 m6">
                      <input
                        type="text"
                        id="phone2"
                        v-model="editedItem.phone2"
                      >
                      <label for="phone2">Phone 2</label>
                      <span class="helper-text red-text">{{ (formErrors.phone2 !== '') ? formErrors.phone2 : '' }}</span>
                    </div>
                  </div>
                </div>

                <div class="card-action">
                  <a
                    class="waves-effect waves-light btn grey lighten-3 black-text"
                    @click="closeDialogEdit"
                  >
                    Cancel
                  </a>

                  <a
                    class="waves-effect waves-light btn success right"
                    :disabled="saveInProgress"
                    @click="saveForm"
                  >
                    <div v-if="saveInProgress" class="saving-animation">
                      <div class="lds-ripple">
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <i v-if="!saveInProgress" class="material-icons left">check</i>
                    Save
                  </a>
                </div>
              </div>
            </div>

          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// Import the API functions
import httpApi from '@/utils/api'

// Date formatting helper
import format from 'date-fns/format'

export default {
  props: ['k'],

  data () {
    return {
      errorList: '',

      subscribeComplete: false,

      // Loading status
      loadingAnimation: true,

      // Variables to save user details
      invoiceID: '',
      shippingLocationID: '',
      planDuration: '',

      categoryID: 0,
      categoryList: [],

      deliveryAddressList: [],
      deliveryAddressID: -1,

      deliveryDetails: {
        childName: '',
        name: '',
        address: '',
        landmark: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        phone1: '',
        phone2: ''
      },

      // Controls which month the plan list starts from
      cutOffDate: 10,
      planStartList: [],
      planStart: '',

      /**
       * Items for dialog form
       */
      // Dialog active?
      dialogEdit: null,
      saveInProgress: false,

      // Form bound variables being edited
      editedItem: {
        id: 0,
        childName: '',
        dateOfBirth: '',
        name: '',
        address: '',
        landmark: '',
        deliveryCity: '',
        city: '',
        state: '',
        country: 'India',
        pincode: '',
        phone1: '',
        phone2: ''
      },

      // Default items used to reset the form
      defaultItem: {
        id: 0,
        childName: '',
        dateOfBirth: '',
        name: '',
        address: '',
        landmark: '',
        deliveryCity: '',
        city: '',
        state: '',
        country: 'India',
        pincode: '',
        phone1: '',
        phone2: ''
      },

      // Error holders for form fields
      formErrors: {
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        deliveryCity: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone1: null,
        phone2: null
      },

      // Default error holders used to reset the form
      defaultFormErrors: {
        childName: null,
        dateOfBirth: null,
        name: null,
        address: null,
        landmark: null,
        deliveryCity: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone1: null,
        phone2: null
      }
    }
  },

  mounted () {
    if (this.k !== '') {
      this.uniqueKey = this.k

      this.getSubscriptionDetails()
        .then(() => {
          this.getCategoryList()
            .then(() => {
              // Get delivery address list for user to choose delivery contact
              this.getDeliveryAddressList(this.shippingLocationID)
                .then(() => {
                  this.setupPlanStartList()
                    .then(() => {
                      setTimeout(() => {
                        var elems1 = document.querySelectorAll('select')
                        // eslint-disable-next-line
                        var instances1 = M.FormSelect.init(elems1, {
                          dropdownOptions: {
                            coverTrigger: false
                          }
                        })

                        var elems2 = document.querySelectorAll('.modal')
                        // eslint-disable-next-line
                        var instances2 = M.Modal.init(elems2)
                        // eslint-disable-next-line
                        this.dialogEdit = M.Modal.getInstance(document.getElementById('editModal'))

                        var elems3 = document.querySelectorAll('.datepicker')
                        // eslint-disable-next-line
                        var maxDate = new Date()
                        // eslint-disable-next-line
                        var instances3 = M.Datepicker.init(elems3, {
                          // Datepicker within a modal looks wrong, if not placed on body
                          container: 'body',
                          format: 'dd mmm yyyy',
                          maxDate: maxDate,
                          // 25+ year olds are not kids, right?
                          yearRange: [(maxDate.getFullYear() - 25), maxDate.getFullYear()]
                        })

                        this.loadingAnimation = false
                      }, 500)
                    })
                    .catch((err) => {
                      this.errorList = err.message
                    })
                })
                .catch((err) => {
                  this.errorList = err.message
                })
            })
            .catch((err) => {
              this.errorList = err.message
            })
        })
        .catch((err) => {
          this.errorList = err.message
        })
    }
  },

  watch: {
    deliveryAddressID (key) {
      if (key === 'ADD') {
        this.openNewDialog()
      } else {
        Object.assign(this.deliveryDetails, this.deliveryAddressList[key])
      }
    }
  },

  methods: {
    getSubscriptionDetails () {
      return new Promise((resolve, reject) => {
        httpApi.callWithToken({
          url: 'subscription/pending2?k=' + this.uniqueKey,
          method: 'get'
        })
          .then((resp) => {
            // Assign details
            this.invoiceID = resp.data.invoiceID
            this.defaultItem.city = resp.data.deliveryCity
            this.shippingLocationID = resp.data.shippingLocationID
            this.planDuration = resp.data.planDuration
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    setupPlanStartList () {
      return new Promise((resolve, reject) => {
        let today = new Date()
        let firstMonth = today.getDate() <= this.cutOffDate ? (today.getMonth()) : (today.getMonth() + 1)
        let firstYear = today.getFullYear()

        this.planStart = format(new Date(firstYear, firstMonth, 15), 'YYYY-MM-DD')

        this.planStartList = [
          { key: format(new Date(firstYear, firstMonth, 15), 'YYYY-MM-DD'), date: format(new Date(firstYear, firstMonth, 15), 'MMM YYYY') },
          { key: format(new Date(firstYear, (firstMonth + 1), 15), 'YYYY-MM-DD'), date: format(new Date(firstYear, (firstMonth + 1), 15), 'MMM YYYY') },
          { key: format(new Date(firstYear, (firstMonth + 2), 15), 'YYYY-MM-DD'), date: format(new Date(firstYear, (firstMonth + 2), 15), 'MMM YYYY') }
        ]
        resolve()
      })
    },

    getDeliveryAddressList (shippingLocationID) {
      // Promise a return
      return new Promise((resolve, reject) => {
        httpApi.callWithToken({
          url: 'address?locationID=' + this.shippingLocationID,
          method: 'get'
        })
          .then((resp) => {
            this.editedItem.city = this.shippingLocationID === 1 ? 'Indore' : ''
            this.deliveryAddressList = resp.data.items

            this.deliveryAddressList.forEach((value, key) => {
              if (value.ship_default > 0) {
                // Assign subscription plan details
                this.deliveryDetails = value
                this.deliveryAddressID = key
              }
            })

            if (this.deliveryAddressID === -1 && this.deliveryAddressList.length > 0) {
              // Assign subscription plan details
              Object.assign(this.deliveryDetails, this.deliveryAddressList[0])
              this.deliveryAddressID = '0'
            }
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    getCategoryList () {
      // Promise a return
      return new Promise((resolve, reject) => {
        httpApi.callWithKey({
          url: 'category',
          method: 'get'
        })
          .then((resp) => {
            // Set the items
            this.categoryList = Object.assign({}, resp.data.items)
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    chooseCategory (categoryID) {
      this.categoryID = categoryID
    },

    completeSubscription () {
      this.saveInProgress = true

      let valid = true
      this.errorList = ''

      if (this.categoryID <= 0) {
        this.errorList += 'Please select an age group. '
        valid = false
      }

      if (this.deliveryAddressList.length <= 0 || this.deliveryAddressID === 'ADD') {
        this.errorList += 'Please select an address or add a new one. '
        valid = false
      }

      if (valid) {
        let dataBody = {
          uniqueKey: this.uniqueKey,
          deliveryAddressID: this.deliveryAddressList[this.deliveryAddressID].id,
          categoryID: this.categoryID,
          planStart: this.planStart
        }

        // Save to API
        httpApi.callWithToken({
          url: 'subscription/complete',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            // Show success message
            this.subscribeComplete = true
          })
          .catch((err) => {
            // Hide loading animation
            this.saveInProgress = false

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      } else {
        this.saveInProgress = false
      }
    },

    // Add an address
    saveForm () {
      this.saveInProgress = true

      // Validate user input data
      let valid = true

      if (this.editedItem.childName === '') {
        this.formErrors.childName = 'Please enter recipient\'s name'
        valid = false
      } else {
        this.formErrors.childName = ''
      }

      if (this.editedItem.dateOfBirth === '') {
        this.formErrors.dateOfBirth = 'Please enter recipient\'s date of birth'
        valid = false
      } else {
        this.formErrors.dateOfBirth = ''
      }

      if (this.editedItem.name === '') {
        this.formErrors.name = 'Please enter the parent\'s / adult\'s name'
        valid = false
      } else {
        this.formErrors.name = ''
      }

      if (this.editedItem.address === '') {
        this.formErrors.address = 'Please enter an address'
        valid = false
      } else {
        this.formErrors.address = ''
      }

      if (this.editedItem.landmark === '') {
        this.formErrors.landmark = 'Please enter a landmark'
        valid = false
      } else {
        this.formErrors.landmark = ''
      }

      if (this.editedItem.pincode === '') {
        this.formErrors.pincode = 'Please enter the postal code'
        valid = false
      } else {
        this.formErrors.pincode = ''
      }

      if (this.editedItem.state === '') {
        this.formErrors.state = 'Please enter the state'
        valid = false
      } else {
        this.formErrors.state = ''
      }

      if (valid) {
        // Create API data body
        let dataBody = {
          childName: this.editedItem.childName,
          dateOfBirth: this.editedItem.dateOfBirth,
          name: this.editedItem.name,
          address: this.editedItem.address,
          landmark: this.editedItem.landmark,
          city: this.editedItem.city,
          deliveryCity: this.shippingLocationID,
          state: this.editedItem.state,
          country: this.editedItem.country,
          pincode: this.editedItem.pincode,
          phone1: this.editedItem.phone1,
          phone2: this.editedItem.phone2
        }

        // Save to API
        httpApi.callWithToken({
          url: 'address',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            // Show success message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'success',
              message: resp.message
            })

            // Update list with new code
            this.editedItem.id = resp.data.addressID
            this.editedItem.ship_default = resp.data.ship_default.toString()

            // Add new item to main list
            this.deliveryAddressList.push(this.editedItem)
            this.deliveryAddressID = this.deliveryAddressList.indexOf(this.editedItem)

            setTimeout(() => {
              var elems = document.querySelectorAll('select')
              // eslint-disable-next-line
              var instances = M.FormSelect.init(elems)
            }, 200)

            // Close and reset dialog
            this.closeDialogEdit()

            // Clear previous errors (no addresses)
            this.errorList = ''
            this.saveInProgress = false
          })
          .catch((err) => {
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set field's error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      } else {
        this.saveInProgress = false
      }
    },

    // Setup the new dialog
    openNewDialog () {
      // Set default formErrors
      this.formErrors = Object.assign({}, this.defaultFormErrors)

      // Set the form values to the values of the selected item
      this.editedItem = Object.assign({}, this.defaultItem)

      // Show edit dialog
      this.dialogEdit.open()
      setTimeout(() => {
        // eslint-disable-next-line
        M.updateTextFields()
      }, 100)
    },

    // Reset the edit variables and close dialog
    closeDialogEdit () {
      setTimeout(() => {
        // Set default formErrors
        this.formErrors = Object.assign({}, this.defaultFormErrors)
        // Set default form fields
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
      this.dialogEdit.close()
    }
  }
}
</script>
